import axios from "axios";

export function createAccounts(data) {
  let configAccount = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts`,
    data: data
  };

  return axios(configAccount);
}

export function createBusinesses(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${data.accountId}/businesses`,
    data: data
  };
  return axios(config);
}

export function createRichmenu(accountId ,data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(config);
}

export function createDefaultItem(accountId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/default-item`,
    data: {}
  };
  return axios(config);
}

export function createContract(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/contract`,
    data: data
  };
  return axios(config);
}

export function enable(accountId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/sys/enabled`,
    data: {
      accountId
    }
  };
  return axios(config);
}

export function disable(accountId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/sys/disabled`,
    data: {
      accountId
    }
  };
  return axios(config);
}

export function createPromotion(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.businessId}/promotions`,
    data: data
  };
  return axios(config);
}

export function promotionSetting(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.businessId}/promotions/${data.id}/setting`,
    data: {data}
  };
  return axios(config);
}

export function updateInitializedStatus(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.id}/initail-status`,
    data: {data}
  };
  return axios(config);
}